function paginationScrollTo() {
  const paginationScrollElement = document.querySelector('#scroll-to');
  const pagination = document.querySelectorAll('.wp-block-query-pagination a');

  // Check if after reloading the page should be scrolled to the element
  if (paginationScrollElement && sessionStorage.getItem('scrollToPagination') === 'true') {
    paginationScrollElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
    // Remove the flag after scrolling
    sessionStorage.removeItem('scrollToPagination');
  }

  // Add click event listeners to pagination links
  pagination.forEach(function(link) {
    link.addEventListener('click', function(e) {
      // Add a flag to indicate that the page should be scrolled to the element
      sessionStorage.setItem('scrollToPagination', 'true');
    });
  });

  function scrollToPaginationElement() {
    if (paginationScrollElement) {
      paginationScrollElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }

  function attachPaginationListeners() {
    const pagination = document.querySelectorAll('.wp-block-query-pagination a');

    pagination.forEach(function(link) {
      // Remove existing listeners to avoid duplicates
      link.removeEventListener('click', handlePaginationClick);
      link.addEventListener('click', handlePaginationClick);
    });
  }

  function handlePaginationClick(e) {
    // Wait for content to load and then scroll
    setTimeout(() => {
      scrollToPaginationElement();
    }, 300);

    // Fallback - try again after longer delay in case content loads slower
    setTimeout(() => {
      scrollToPaginationElement();
    }, 800);
  }

  // Initial attachment of listeners
  attachPaginationListeners();

  // Watch for new pagination elements being added to DOM
  const observer = new MutationObserver(function(mutations) {
    let shouldReattachListeners = false;

    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Check if pagination elements were added
        const hasNewPagination = Array.from(mutation.addedNodes).some(node =>
          node.nodeType === 1 &&
          (node.querySelector && node.querySelector('.wp-block-query-pagination a') ||
            node.matches && node.matches('.wp-block-query-pagination a'))
        );

        if (hasNewPagination) {
          shouldReattachListeners = true;
        }
      }
    });

    if (shouldReattachListeners) {
      // Small delay to ensure DOM is fully updated
      setTimeout(() => {
        attachPaginationListeners();
        // Auto-scroll after new content is loaded
        scrollToPaginationElement();
      }, 100);
    }
  });

  // Start observing the document for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Alternative approach: Listen for common AJAX completion events
  document.addEventListener('DOMContentLoaded', attachPaginationListeners);

  // Listen for custom events that might be fired after AJAX content loads
  document.addEventListener('contentLoaded', () => {
    setTimeout(() => {
      attachPaginationListeners();
      scrollToPaginationElement();
    }, 100);
  });

  // Cleanup function
  return function cleanup() {
    observer.disconnect();
    const pagination = document.querySelectorAll('.wp-block-query-pagination a');
    pagination.forEach(function(link) {
      link.removeEventListener('click', handlePaginationClick);
    });
  };
}

export { paginationScrollTo };



